export const ACTIONABLE_APPROVAL_STATUSES = ['contested', 'pending_review', 'pending_feedback'] as const;

const ACTIONABLE_APPROVAL_STATUS_SET = new Set<string>(ACTIONABLE_APPROVAL_STATUSES);

export function isActionableApprovalStatus(status?: string | null): boolean {
  if (!status) return false;
  return ACTIONABLE_APPROVAL_STATUS_SET.has(status);
}

